// @core/api/endpoints/workflow/list_node_types.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { getApiClient, type RequestOptions } from '../../client';
import type {
  ListNodeTypesResponse,
} from '../../../types/workflow';
import type { PaginatedRequest } from '../../../types/pagination';

const BASE_PATH = '/workflow';

/**
 * List node types
 * Returns all available node types for the visual editor. Supports filtering by category, product, and built-in status.
 */
export async function ListNodeTypes(
  params?: PaginatedRequest,
  options?: RequestOptions
): Promise<ListNodeTypesResponse> {
  const client = getApiClient();
  const requestPath = `${BASE_PATH}/workflows/node-types`;
  const requestOptions = options;
  return client.get<ListNodeTypesResponse>(requestPath, { ...requestOptions, params });
}
